export const APP_INFO = {
  name: "Sublime",
  productLine: "Personal Fitness OS",
  ownerName: "Jaleel Norodien",
  ownerHandle: "jnorodien",
  repository: "github.com/jnorodien/fitlog",
  webVersion: "1.0.1",
  releaseChannel: process.env.NODE_ENV === "production" ? "cloudflare-pages" : "local-dev",
};

export const VERSION_HISTORY_KEY = "sublime_version_history";

export function normalizeNativeInfo(info) {
  if (!info || typeof info !== "object") return null;
  return {
    platform: String(info.platform || "android"),
    shell: String(info.shell || "sublime-sync"),
    version: String(info.version || ""),
    buildNumber: String(info.buildNumber || info.build || ""),
    channel: String(info.channel || ""),
  };
}

export function shortHash(value) {
  return value ? String(value).slice(0, 8) : "";
}

export function readVersionHistory() {
  try {
    const rows = JSON.parse(localStorage.getItem(VERSION_HISTORY_KEY) || "[]");
    return Array.isArray(rows) ? rows : [];
  } catch {
    return [];
  }
}

export function recordVersionSnapshot(nativeInfo) {
  if (typeof window === "undefined") return [];
  const native = normalizeNativeInfo(nativeInfo);
  const signature = [
    APP_INFO.webVersion,
    native?.version || "browser",
    native?.buildNumber || "",
    native?.platform || "web",
  ].join("|");

  const now = new Date().toISOString();
  const history = readVersionHistory();
  if (history[0]?.signature === signature) {
    history[0] = { ...history[0], lastSeenAt: now };
  } else {
    history.unshift({
      signature,
      firstSeenAt: now,
      lastSeenAt: now,
      webVersion: APP_INFO.webVersion,
      releaseChannel: APP_INFO.releaseChannel,
      native,
      origin: window.location.origin,
    });
  }

  const trimmed = history.slice(0, 12);
  try {
    localStorage.setItem(VERSION_HISTORY_KEY, JSON.stringify(trimmed));
  } catch {}
  return trimmed;
}
